import { useQuery } from "@tanstack/react-query";
import articlesList from "Api/articles/list";
import { ArticleRequestList } from "Services/Article/article";

export function useArticles(params: ArticleRequestList) {
  const query = () => articlesList(params);

  return useQuery(["articlesList", ...Object.values(params)], query);
}
